import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../components/LoadingIndicator';
import { Container } from '../../components/layout/ContainerFlex';
import ActualityAggregatedStatsControls from './ActualityAggregatedStatsControls';
import ActualityAggregatedStatsHeader from './ActualityAggregatedStatsHeader';
import ActualityAggregatedStatsTimeline from './ActualityAggregatedStatsTimeline';

const FeedActivityKPIRoot: React.FC = () => {
  const { t } = useTranslation('feed');

  return (
    <Container data-component="FeedActivityKPIRoot" flex1 col>
      <ActualityAggregatedStatsHeader />
      <ActualityAggregatedStatsControls />
      {/* <ActualityAggregatedStatsFilters /> */}

      <Container col>
        <Suspense
          fallback={
            <Container col className="relative p-2">
              <LoadingIndicator
                absolute
                message={t`Loading Visualisation`}
                selfCenter
              />
            </Container>
          }
        >
          <ActualityAggregatedStatsTimeline />
        </Suspense>
      </Container>
    </Container>
  );
};

export default FeedActivityKPIRoot;
